var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          "left-side-class": "col-xl-4",
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        },
        scopedSlots: _vm._u(
          [
            !_vm.showChangeBillingStatus
              ? {
                  key: "customActions",
                  fn: function() {
                    return [
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-arrow-circle-left",
                            variant: "success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.goToBillingHistorySearch()
                            }
                          }
                        },
                        [_vm._v(" Regresar ")]
                      ),
                      _c("div", { staticClass: "dropdown" }, [
                        _vm.userHasPermissions(
                          "provider.billing.history.report"
                        )
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-dropdown-actions dropdown-toggle float-left pt-1 color-green font-weight-bold d-flex justify-content-center align-items-center mx-2",
                                attrs: {
                                  id: "dropdownMenuButton",
                                  "aria-expanded": "false",
                                  "aria-haspopup": "true",
                                  "data-toggle": "dropdown",
                                  type: "button"
                                }
                              },
                              [
                                _c("em", {
                                  staticClass: "fa fa-file-alt text-green pr-2"
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "color-green font-weight-bold"
                                  },
                                  [_vm._v("Informes")]
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown-menu dropdown-menu-right custom-dropdown-container",
                            attrs: { "aria-labelledby": "dropdownMenuButton" }
                          },
                          _vm._l(_vm.reportButtonAvailables, function(
                            reportButton,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "dropdown-item cursor-pointer mb-1",
                                on: { click: reportButton.callback }
                              },
                              [
                                _c("em", {
                                  staticClass: "fa fa-file-alt text-green pr-1"
                                }),
                                _c("span", [_vm._v(_vm._s(reportButton.text))])
                              ]
                            )
                          }),
                          0
                        )
                      ]),
                      _vm.showDistributionButton
                        ? _c(
                            "action-button",
                            {
                              attrs: {
                                i: "fas fa-file-search",
                                variant: "success"
                              },
                              on: { click: _vm.onShowDistributionDetailsPanel }
                            },
                            [_vm._v(" Detalles de Distribución ")]
                          )
                        : _vm._e(),
                      _vm.userHasPermissions("provider.bill.total.update") &&
                      _vm.isPreliminar &&
                      _vm.isActiveTabSummary
                        ? _c(
                            "action-button",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                i: "fas fa-redo-alt",
                                variant: "success"
                              },
                              on: { click: _vm.updateBillTotals }
                            },
                            [_vm._v(" Actualizar Factura ")]
                          )
                        : _vm._e(),
                      _vm.enableSubmitBilling
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-flag",
                              text: "Someter",
                              variant: "success ml-2"
                            },
                            on: { click: _vm.onSubmitBill }
                          })
                        : _vm._e(),
                      _vm.enableChangeBillingStatus
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-exchange-alt",
                              text: "Cambiar Estatus",
                              variant: "success ml-2"
                            },
                            on: { click: _vm.onChangeBillingStatusForm }
                          })
                        : _vm._e(),
                      _vm.canDoPartialPayment
                        ? _c("action-button", {
                            attrs: {
                              i: "fa fa-usd-square",
                              text: "Pago Parcial",
                              variant: "success ml-2"
                            },
                            on: { click: _vm.addPartialPayments }
                          })
                        : _vm._e(),
                      _vm.canAjustBill
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-money-check-alt",
                              text: "Ajustar Factura",
                              variant: "success ml-2"
                            },
                            on: { click: _vm.onBillingAdjustmentForm }
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        )
      }),
      _vm.enableChangeBillingStatus && _vm.showChangeBillingStatus
        ? _c(
            "div",
            [
              _c(
                "custom-callout",
                {
                  staticClass: "mb-4 custom-callout-invoice shadow",
                  attrs: { "border-color": "green", "has-toggle": false }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("icon-view", {
                          attrs: {
                            icon: "fa fa-clipboard-list-check",
                            "icon-background": "#fff",
                            "icon-color": "#2db782",
                            "icon-size": "16px",
                            title: "Cambiar Estatus de Factura"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "validation-observer",
                    {
                      ref: "submitUpdateBillingStatusRef",
                      attrs: { novalidate: "", tag: "form" }
                    },
                    [
                      _c("div", { staticClass: "row ml-2 mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-3 col-sm-12" },
                          [
                            _c("div", { staticClass: "gray-6 font-14 mb-2" }, [
                              _vm._v(" Nuevo Estatus: ")
                            ]),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            clearable: false,
                                            "custom-error-msg":
                                              "Favor de seleccionar el nuevo estatus.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            options:
                                              _vm.billingStatusListAvailable,
                                            placeholder: "Seleccione"
                                          },
                                          model: {
                                            value:
                                              _vm.billingStatusModel
                                                .billStatusId,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.billingStatusModel,
                                                "billStatusId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "billingStatusModel.billStatusId"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1463788748
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-6 col-sm-12" },
                          [
                            _c("div", { staticClass: "gray-6 font-14 mb-2" }, [
                              _vm._v(" Comentario: ")
                            ]),
                            _c("validation-provider", {
                              attrs: {
                                rules: _vm.requiredChangeStatusComment
                                  ? "required"
                                  : ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor de entrar un comentario.",
                                            error: errors[0]
                                          },
                                          model: {
                                            value:
                                              _vm.billingStatusModel.comment,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.billingStatusModel,
                                                "comment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "billingStatusModel.comment"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                394284959
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-3 text-right mt-4" },
                          [
                            _c(
                              "action-button",
                              {
                                staticClass: "w-45",
                                attrs: {
                                  i: "fas fa-times-circle",
                                  variant:
                                    "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                },
                                on: { click: _vm.onCancelBillingStatusHandler }
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-arrow-circle-right",
                                  variant: "success pl-4 pr-4"
                                },
                                on: { click: _vm.onChangeBillingStatusHandler }
                              },
                              [_vm._v(" Continuar ")]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm.enableExtraFieldChangeStatus(
                        _vm.billingStatusModel.billStatusId
                      )
                        ? _c("div", { staticClass: "ml-4" })
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.showDistribution
        ? _c("billing-distribution-details", {
            attrs: { data: _vm.distributionInfo },
            on: {
              "on-close": function($event) {
                return _vm.onShowDistributionDetailsPanel($event)
              }
            }
          })
        : _vm._e(),
      _vm.showGeneralAdjustmentForm
        ? _c(
            "div",
            [
              _c(
                "custom-callout",
                {
                  staticClass: "mb-4 custom-callout-invoice shadow",
                  attrs: { "border-color": "green", "has-toggle": false }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("icon-view", {
                          attrs: {
                            icon: "fas fa-money-check-alt",
                            "icon-background": "#fff",
                            "icon-color": "#2db782",
                            "icon-size": "16px",
                            title: "Ajuste de Factura"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "validation-observer",
                    {
                      ref: "generalAdjustmentRef",
                      attrs: { novalidate: "", tag: "form" }
                    },
                    [
                      _c("div", { staticClass: "row ml-2 mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-6 col-sm-12" },
                          [
                            _c("div", { staticClass: "gray-6 font-14 mb-2" }, [
                              _vm._v(" Razón: ")
                            ]),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            clearable: false,
                                            "custom-error-msg":
                                              "Favor seleccionar razón del ajuste.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            options: _vm.reasons,
                                            placeholder: "Seleccione"
                                          },
                                          on: { input: _vm.onReasonChange },
                                          model: {
                                            value:
                                              _vm.generalAdjustmentModel.reason,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.generalAdjustmentModel,
                                                "reason",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "generalAdjustmentModel.reason"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                679407242
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-3 col-sm-12" },
                          [
                            _c(
                              "div",
                              { staticClass: "font-14 color-gray-6 mb-1" },
                              [_vm._v(" Cantidad: ")]
                            ),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "input-group mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-amount-dollar"
                                              },
                                              [
                                                _c("em", {
                                                  staticClass:
                                                    "fa fa-dollar-sign"
                                                })
                                              ]
                                            ),
                                            _c("custom-input", {
                                              staticClass: "w-80",
                                              attrs: {
                                                "custom-error-msg": "",
                                                error: errors[0],
                                                type: "number"
                                              },
                                              model: {
                                                value:
                                                  _vm.generalAdjustmentModel
                                                    .amount,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.generalAdjustmentModel,
                                                    "amount",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "generalAdjustmentModel.amount"
                                              }
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-amount-action"
                                              },
                                              [
                                                _c("em", {
                                                  staticClass:
                                                    "fa fa-plus-circle",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onChangeAmountSign(
                                                        "positive"
                                                      )
                                                    }
                                                  }
                                                }),
                                                _c("em", {
                                                  staticClass:
                                                    "fa fa-minus-circle",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onChangeAmountSign(
                                                        "negative"
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c("error", {
                                              attrs: {
                                                message:
                                                  "Cantidad del ajuste es requerida.",
                                                variant: "no-border mt-n3"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3504007855
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-9 col-sm-12" },
                          [
                            _c("div", { staticClass: "gray-6 font-14 mb-2" }, [
                              _vm._v(" Comentario: ")
                            ]),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Comentario es requerido para registrar el ajuste.",
                                            error: errors[0]
                                          },
                                          model: {
                                            value:
                                              _vm.generalAdjustmentModel
                                                .comment,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.generalAdjustmentModel,
                                                "comment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "generalAdjustmentModel.comment"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1950830025
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-3 text-right mt-4" },
                          [
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-times-circle",
                                  variant:
                                    "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                },
                                on: { click: _vm.onBillingAdjustmentForm }
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-arrow-circle-right",
                                  variant: "success pl-4 pr-4"
                                },
                                on: { click: _vm.onSaveGeneralAdjustment }
                              },
                              [_vm._v(" Guardar ")]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("board", { attrs: { details: _vm.invoiceDetailsBoard } }),
      _c(
        "div",
        { staticClass: "mt-5" },
        [
          _c("section-title", {
            attrs: { "has-line": true, title: "Información de Factura" }
          }),
          _c(
            "div",
            [
              _c(
                "custom-tab",
                {
                  staticClass: "custom-nav-container",
                  attrs: {
                    "active-tab-class": "",
                    "content-class": "mt-3",
                    "no-nav-style": true
                  }
                },
                [
                  _c(
                    "custom-tab-item",
                    {
                      attrs: {
                        active:
                          _vm.billingInfoTabIndex ===
                          _vm.billingInfoTabs.SUMMARY,
                        lazy: "",
                        title: "Resumen"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onChangeInfoTab(
                            _vm.billingInfoTabs.SUMMARY
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-4 col col-sm-6" },
                          [
                            _c("total-amount-view", {
                              attrs: {
                                amount: _vm._f("price")(
                                  _vm.summaryTotals.subTotal
                                ),
                                icon: "fa fa-usd-circle",
                                "icon-color": "color-yellow-star",
                                title: "Total Facturado"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 col col-sm-6 mt-3 mt-md-0 mt-sm-3"
                          },
                          [
                            _c("total-amount-view", {
                              attrs: {
                                amount: _vm._f("price")(
                                  _vm.summaryTotals.adjustment
                                ),
                                icon: "fa fa-usd-circle",
                                "icon-color": "color-primary-8",
                                title: "Total de Ajustes en Factura"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 col col-sm-6 mt-md-0 mt-sm-3 mt-3 mt-md-0 mt-sm-3"
                          },
                          [
                            _c("total-amount-view", {
                              attrs: {
                                amount: _vm._f("price")(
                                  _vm.summaryTotals.total
                                ),
                                icon: "fa fa-usd-circle",
                                "icon-color": "color-green",
                                title: "Total a Pagar"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("hr"),
                      _c("div", { staticClass: "row mt-4 mb-3 ml-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 col-sm-12 mt-md-0 mt-sm-3 ml-n4 ml-md-n0 ml-sm-n4 mr-4"
                          },
                          [
                            _c("service-type-view", {
                              attrs: {
                                "amount-sub-total": _vm._f("price")(
                                  _vm.serviceTotals.therapyServiceAmount
                                ),
                                collapsed: _vm.showInterventionService,
                                details: _vm.interventionServiceDetail,
                                "enable-toggle": "",
                                "main-icon": "fa fa-clipboard-list",
                                "main-title":
                                  "Resumen de Servicio de Intervención",
                                "service-total": _vm.serviceTotals
                                  .therapyServiceCount
                                  ? _vm.serviceTotals.therapyServiceCount.toString()
                                  : "0",
                                "show-total": _vm.canShowTotalDetail
                              },
                              on: { "on-toggle": _vm.onToggleServiceInfo }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 col-sm-12 mt-5 mt-md-0 mt-sm-5 corner-line ml-n4 ml-md-n0 ml-sm-n4 mr-4"
                          },
                          [
                            _c("service-type-view", {
                              attrs: {
                                "amount-sub-total": _vm._f("price")(
                                  _vm.serviceTotals.evaluationServiceAmount
                                ),
                                details: _vm.evaluationServiceDetail,
                                "main-icon": "fa fa-clipboard-list",
                                "main-title": "Resumen de Evaluación",
                                "service-total": _vm.serviceTotals
                                  .evaluationServiceCount
                                  ? _vm.serviceTotals.evaluationServiceCount.toString()
                                  : "0",
                                "show-total": _vm.canShowTotalDetail
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 col-sm-12 mt-5 mt-md-0 mt-sm-5 ml-n4 ml-md-n0 ml-sm-n4"
                          },
                          [
                            _c("service-type-view", {
                              attrs: {
                                "amount-sub-total": _vm._f("price")(
                                  _vm.serviceTotals.otherServiceAmount
                                ),
                                "amount-total":
                                  _vm.serviceTotals.otherServiceAmount +
                                  _vm.serviceTotals
                                    .otherServiceAdjustmentAmount,
                                "main-icon": "fa fa-clipboard-list",
                                "main-title": "Resumen de Otros Servicios",
                                "service-total": _vm.serviceTotals
                                  .otherServiceCount
                                  ? _vm.serviceTotals.otherServiceCount.toString()
                                  : "0",
                                "show-total": _vm.canShowTotalDetail,
                                "use-detail": false
                              }
                            }),
                            _c("service-type-view", {
                              staticClass: "mt-3",
                              attrs: {
                                "amount-sub-total": _vm._f("price")(
                                  _vm.serviceTotals.educationalServiceAmount
                                ),
                                collapsed: _vm.showEducationalServiceResume,
                                details: _vm.educationalServiceDetail,
                                "enable-toggle": "",
                                "main-icon": "fa fa-clipboard-list",
                                "main-title": "Resumen de Servicios Educativos",
                                "service-total": _vm.serviceTotals
                                  .educationalServiceCount
                                  ? _vm.serviceTotals.educationalServiceCount.toString()
                                  : "0"
                              },
                              on: {
                                "on-toggle": function($event) {
                                  {
                                    _vm.showEducationalServiceResume = !_vm.showEducationalServiceResume
                                  }
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("service-type-info-view", {
                        staticClass: "mt-n2 ml-5",
                        attrs: {
                          "admission-info":
                            _vm.interventionServiceInfo.admission,
                          collapsed: _vm.showInterventionService,
                          "plan-info": _vm.interventionServiceInfo.plan,
                          "visit-info": _vm.interventionServiceInfo.visit
                        },
                        on: { "on-toggle": _vm.onToggleServiceInfo }
                      }),
                      _c("service-type-educational-info-view", {
                        staticClass: "mt-n2 ml-5",
                        attrs: {
                          collapsed: _vm.showEducationalServiceResume,
                          "educational-service-resume-details":
                            _vm.educationalServiceresume
                        },
                        on: {
                          "on-toggle": function($event) {
                            {
                              _vm.showEducationalServiceResume = !_vm.showEducationalServiceResume
                            }
                          }
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "my-4 ml-n1" },
                        [
                          _c("icon-view", {
                            staticClass: "ml-1 mt-5 mt-md-0 mt-sm-5",
                            attrs: {
                              gradient: "",
                              icon: "fa fa-clipboard-list",
                              "icon-background": "#C5525C",
                              "icon-color": "#fff",
                              title: "Resumen de Alerta de Servicios"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "row mt-3 ml-0 ml-md-1 ml-sm-0" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-4" },
                                [
                                  _c("service-alert-view", {
                                    attrs: {
                                      count: _vm.alerts.errorVisits,
                                      description:
                                        "Servicios en la factura que tienen error en las visitas registradas.",
                                      "main-title": "Error de Visitas:"
                                    },
                                    on: { print: _vm.getErrorVisit }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-4" },
                                [
                                  _c("service-alert-view", {
                                    attrs: {
                                      count: _vm.alerts.noEnded,
                                      description:
                                        "Servicios en la factura que no han sido finalizados.",
                                      "main-title": "No Finalizados:"
                                    },
                                    on: { print: _vm.getWithouFinish }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-4" },
                                [
                                  _c("service-alert-view", {
                                    attrs: {
                                      count: _vm.alerts.withoutCertification,
                                      description:
                                        "Servicios en la factura que no tienen anejado la certificación de visita.",
                                      "main-title":
                                        "Sin Certificación de Visita:"
                                    },
                                    on: { print: _vm.getWithoutCertification }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "custom-tab-item",
                    {
                      attrs: {
                        active:
                          _vm.billingInfoTabIndex ===
                          _vm.billingInfoTabs.DETAIL,
                        lazy: "",
                        title: "Detalle"
                      },
                      on: {
                        click: () => {
                          _vm.onChangeInfoTab(_vm.billingInfoTabs.DETAIL)
                        }
                      }
                    },
                    [
                      !_vm.editingDistributionNumber
                        ? _c("div", { staticClass: "bg-gray-1 p-3 rounded" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-3" },
                                [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: true,
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Grupo de Edad:",
                                      options: _vm.ageGroupList,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value:
                                        _vm.selectedFilters.serviceCategory,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedFilters,
                                          "serviceCategory",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedFilters.serviceCategory"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-3" },
                                [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: true,
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Tipo de Servicio:",
                                      options: _vm.filters.serviceTypes,
                                      placeholder: "Seleccione"
                                    },
                                    on: {
                                      input: _vm.onChangeBillingServiceType
                                    },
                                    model: {
                                      value: _vm.selectedFilters.serviceType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedFilters,
                                          "serviceType",
                                          $$v
                                        )
                                      },
                                      expression: "selectedFilters.serviceType"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.showEvaluationTypeFilter
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-3" },
                                    [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          clearable: true,
                                          fieldkey: "id",
                                          fieldname: "name",
                                          label: "Tipo de Evaluación:",
                                          options: _vm.filters.evaluationTypes,
                                          placeholder: "Seleccione"
                                        },
                                        model: {
                                          value:
                                            _vm.selectedFilters.evaluationType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selectedFilters,
                                              "evaluationType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selectedFilters.evaluationType"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-3 mt-3 mt-md-0 mt-sm-3"
                                },
                                [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: true,
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Servicio:",
                                      options: _vm.filters.disciplineTypes,
                                      placeholder: "Seleccione"
                                    },
                                    on: {
                                      input: _vm.onChangeBillingDisciplineType
                                    },
                                    model: {
                                      value: _vm.selectedFilters.disciplineType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedFilters,
                                          "disciplineType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedFilters.disciplineType"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-3",
                                  class: {
                                    "mt-3": _vm.showEvaluationTypeFilter
                                  }
                                },
                                [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: true,
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Especialista:",
                                      options: _vm.filters.specialists,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.selectedFilters.specialist,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedFilters,
                                          "specialist",
                                          $$v
                                        )
                                      },
                                      expression: "selectedFilters.specialist"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.showBillingServiceAlert(
                                _vm.selectedFilters.serviceType
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-3 mt-3" },
                                    [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          clearable: true,
                                          fieldkey: "id",
                                          fieldname: "name",
                                          label: "Alertas:",
                                          options: _vm.serviceAlertTypes,
                                          placeholder: "Seleccione"
                                        },
                                        model: {
                                          value: _vm.selectedFilters.alert,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selectedFilters,
                                              "alert",
                                              $$v
                                            )
                                          },
                                          expression: "selectedFilters.alert"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showBillingServiceSie(
                                _vm.selectedFilters.disciplineType
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-3 mt-3" },
                                    [
                                      _c("custom-input", {
                                        attrs: {
                                          label: "SIE:",
                                          placeholder: "Escriba número de SIE"
                                        },
                                        model: {
                                          value: _vm.selectedFilters.sie,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selectedFilters,
                                              "sie",
                                              $$v
                                            )
                                          },
                                          expression: "selectedFilters.sie"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showInterventionFilter
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-3 mt-3" },
                                    [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          clearable: true,
                                          fieldkey: "value",
                                          fieldname: "name",
                                          label: "Servicio Intervenido:",
                                          options: _vm.checkedOptions,
                                          placeholder: "Seleccione"
                                        },
                                        model: {
                                          value:
                                            _vm.selectedFilters.checkedFlag,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selectedFilters,
                                              "checkedFlag",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selectedFilters.checkedFlag"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col d-flex d-md-block d-sm-flex mt-5 text-right"
                                },
                                [
                                  _c("action-button", {
                                    staticClass: "flex-grow-1",
                                    attrs: {
                                      i: "fas fa-search",
                                      text: "Buscar",
                                      variant: "success"
                                    },
                                    on: {
                                      click: _vm.onSearchBillingServiceHandler
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "div",
                            { staticClass: "row justify-content-end" },
                            [
                              _vm.canSelectNumberType
                                ? _c("div", { staticClass: "col" }, [
                                    _c("div", { staticClass: "d-flex mt-3" }, [
                                      _c("div", { staticClass: "col-auto" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-gray-6 font-14 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " Seleccione el Tipo de Cifra: "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "col" },
                                        [
                                          _c("custom-radio", {
                                            staticClass:
                                              "custom-radio__extended",
                                            attrs: {
                                              id: "isFederalNumber",
                                              "is-inline": "",
                                              name: "isFederalNumber",
                                              options: _vm.numberTypeOptions
                                            },
                                            on: {
                                              input: _vm.onToggleNumberType
                                            },
                                            model: {
                                              value: _vm.isFederalNumber,
                                              callback: function($$v) {
                                                _vm.isFederalNumber = $$v
                                              },
                                              expression: "isFederalNumber"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm.canEditDistributionNumber &&
                              !_vm.editingDistributionNumber
                                ? _c(
                                    "div",
                                    { staticClass: "col-auto" },
                                    [
                                      _c("Link", {
                                        staticClass: "justify-content-end mt-3",
                                        attrs: {
                                          id: "editingDistributionNumber",
                                          icon: "fa fa-edit",
                                          text:
                                            "Modificar Distribución de Cifras de Cuenta"
                                        },
                                        on: {
                                          click: _vm.setDistributionNumberFlag
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.canDownloadMassCertifications
                                ? _c(
                                    "div",
                                    { staticClass: "col-auto" },
                                    [
                                      _c("Link", {
                                        staticClass: "justify-content-end mt-3",
                                        attrs: {
                                          id: "bulkDownload",
                                          icon: "fa fa-file-download",
                                          text:
                                            "Descargar Certificaciones en Masa"
                                        },
                                        on: { click: _vm.bulkDownload }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.canMarkAllAsIntervened
                                ? _c(
                                    "div",
                                    { staticClass: "col-auto" },
                                    [
                                      _c("Link", {
                                        staticClass: "justify-content-end mt-3",
                                        attrs: {
                                          id: "markAllService",
                                          icon: "fa fa-flag",
                                          text:
                                            "Marcar Todos como Servicio Intervenido"
                                        },
                                        on: { click: _vm.markAllService }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm.editingDistributionNumber
                            ? _c(
                                "div",
                                { staticClass: "mt-4" },
                                [
                                  _c("edit-distribution-number", {
                                    attrs: {
                                      "age-group-list": _vm.ageGroupList,
                                      "bill-id": _vm.billId,
                                      "purchase-orders":
                                        _vm.purchaseOrdersByCompany,
                                      "purchase-orders-in-bill":
                                        _vm.projectNumbersInBill
                                    },
                                    on: {
                                      "cancel-edit": function($event) {
                                        return _vm.setDistributionNumberFlag(
                                          false
                                        )
                                      },
                                      updated: _vm.onUpdateDistributionNumber
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "mt-4" },
                            [
                              _vm._l(_vm.pagination.data, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: "service-details" + index },
                                  [
                                    _c(
                                      "custom-callout",
                                      {
                                        staticClass: "mb-3 custom-callout",
                                        attrs: {
                                          controlled: true,
                                          "has-toogle": true,
                                          opened: item.isOpen
                                        },
                                        on: {
                                          "click:open": function($event) {
                                            return _vm.onToggleServiceAdditionalInfo(
                                              item
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "edition",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "p-3 pb-2 custom-callout-edition"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "bg-secondary-3 rounded p-2"
                                                        },
                                                        [
                                                          _c(
                                                            "custom-tab",
                                                            {
                                                              staticClass:
                                                                "custom-tab-visit-details bg-white rounded"
                                                            },
                                                            [
                                                              _c(
                                                                "custom-tab-item",
                                                                {
                                                                  attrs: {
                                                                    active:
                                                                      _vm.visitDetailsTabIndex ===
                                                                      0,
                                                                    "content-class":
                                                                      "mt-3 pb-3",
                                                                    title:
                                                                      "Información Adicional"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onChangeToAdittionalInfo(
                                                                        item,
                                                                        index,
                                                                        0
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "px-4 pb-4"
                                                                    },
                                                                    [
                                                                      _vm.isAdditionalInfoTypeTherapy(
                                                                        item.transactionType
                                                                      )
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-gray-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Número de Referido: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            item.details !=
                                                                                              undefined
                                                                                              ? item
                                                                                                  .details
                                                                                                  .referrenceNumber
                                                                                              : " - "
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-gray-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Modalidad: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            item.details !=
                                                                                              undefined
                                                                                              ? item
                                                                                                  .details
                                                                                                  .modality
                                                                                              : " - "
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-gray-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Frecuencia: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            item.details !=
                                                                                              undefined
                                                                                              ? item
                                                                                                  .details
                                                                                                  .frequency
                                                                                              : " - "
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-gray-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Duración: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            item.details !=
                                                                                              undefined
                                                                                              ? item
                                                                                                  .details
                                                                                                  .duration
                                                                                              : " - "
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-gray-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Lugar de Servicio: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            item.details !=
                                                                                              undefined
                                                                                              ? item
                                                                                                  .details
                                                                                                  .locationService
                                                                                              : " - "
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm.isAdditionalInfoTypeAppointment(
                                                                        item.transactionType
                                                                      )
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row pb-3"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-gray-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Número Cita: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            (item.details !=
                                                                                              undefined) !=
                                                                                              null
                                                                                              ? item
                                                                                                  .details
                                                                                                  .referrenceNumber
                                                                                              : " - "
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-gray-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Lugar de Servicio: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            (item.details !=
                                                                                              undefined) !=
                                                                                              null
                                                                                              ? item
                                                                                                  .details
                                                                                                  .locationService
                                                                                              : " - "
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-gray-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Fecha de Completado: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "font-14 color-black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm.setFormatOrEmpty(
                                                                                              item
                                                                                                .details
                                                                                                .completedDate,
                                                                                              "date"
                                                                                            )
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              item.details &&
                                                                              item
                                                                                .details
                                                                                .hasSignLanguageInterpreter
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "col"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "font-14 color-gray-6"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " Intérprete de Señas "
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "font-14 color-black"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " Sí "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm.isAdditionalInfoTypeConsulting(
                                                                        item.transactionType
                                                                      )
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row p-2"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-md-6 pl-4 border-right"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row"
                                                                                    },
                                                                                    [
                                                                                      _vm.isVisibleMunicipality(
                                                                                        item.disciplineTypeCd
                                                                                      )
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-md-4"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-gray-6"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " Municipio: "
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-black"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " " +
                                                                                                      _vm._s(
                                                                                                        item
                                                                                                          .details
                                                                                                          .municipalityName
                                                                                                      ) +
                                                                                                      " "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm.isVisiblePlace(
                                                                                        item.disciplineTypeCd
                                                                                      )
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-md-4"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-gray-6"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " Lugar: "
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-black"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " " +
                                                                                                      _vm._s(
                                                                                                        item
                                                                                                          .details
                                                                                                          .locationName
                                                                                                      ) +
                                                                                                      " "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm.isVisibleParticipants(
                                                                                        item.disciplineTypeCd
                                                                                      )
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-md-4"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-gray-6"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " Participantes: "
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-black"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " " +
                                                                                                      _vm._s(
                                                                                                        item.details.participants.join(
                                                                                                          " , "
                                                                                                        )
                                                                                                      ) +
                                                                                                      " "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm.isVisibleService(
                                                                                        item.disciplineTypeCd
                                                                                      )
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-md-4"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-gray-6"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " Service: "
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-black"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " " +
                                                                                                      _vm._s(
                                                                                                        item
                                                                                                          .details
                                                                                                          .locationService
                                                                                                      ) +
                                                                                                      " "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm.isVisibleComment(
                                                                                        item.disciplineTypeCd
                                                                                      )
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-md-12 mt-3"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-gray-6"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " Comentario: "
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-black"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " " +
                                                                                                      _vm._s(
                                                                                                        item
                                                                                                          .details
                                                                                                          .comment
                                                                                                      ) +
                                                                                                      " "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e()
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-md-6"
                                                                                },
                                                                                _vm._l(
                                                                                  item
                                                                                    .details
                                                                                    .documents,
                                                                                  function(
                                                                                    serviceDoc,
                                                                                    serviceIndex
                                                                                  ) {
                                                                                    return _c(
                                                                                      "div",
                                                                                      {
                                                                                        key: `service-doc_${serviceIndex}`,
                                                                                        staticClass:
                                                                                          "d-flex flex-row justify-content-center align-items-center bg-secondary-3 py-3 px-3 ounded mr-3 mb-2"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "flex-grow-1"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "font-14 color-gray-6"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " Tipo de Documento: "
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "font-14 color-black"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      serviceDoc.documentTypeName
                                                                                                    ) +
                                                                                                    " "
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _c(
                                                                                          "div",
                                                                                          [
                                                                                            _c(
                                                                                              "action-button",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "custom-print-button",
                                                                                                attrs: {
                                                                                                  i:
                                                                                                    "fas fa-download",
                                                                                                  variant:
                                                                                                    "outline-success"
                                                                                                },
                                                                                                on: {
                                                                                                  click: function(
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.onDownloadServiceDocument(
                                                                                                      serviceDoc
                                                                                                    )
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  }
                                                                                ),
                                                                                0
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm.isAdditionalInfoTypeEducationalService(
                                                                        item.transactionType
                                                                      )
                                                                        ? _c(
                                                                            "educative-additional-info",
                                                                            {
                                                                              attrs: {
                                                                                "show-assignment-dates": false,
                                                                                "show-start-date": true,
                                                                                value:
                                                                                  item.details ||
                                                                                  {}
                                                                              }
                                                                            }
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              ),
                                                              _vm.isThrpyService(
                                                                item
                                                              )
                                                                ? _c(
                                                                    "custom-tab-item",
                                                                    {
                                                                      key: "1",
                                                                      staticClass:
                                                                        "pb-4",
                                                                      attrs: {
                                                                        active:
                                                                          _vm.visitDetailsTabIndex ===
                                                                          1,
                                                                        "content-class":
                                                                          "mt-3 pb-3",
                                                                        title:
                                                                          "Certificación de Visita"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.openCertificationVisit(
                                                                            item,
                                                                            index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "validation-observer",
                                                                        {
                                                                          ref:
                                                                            "submitCertDocRef",
                                                                          refInFor: true,
                                                                          attrs: {
                                                                            novalidate:
                                                                              "",
                                                                            tag:
                                                                              "form"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "document-management",
                                                                            {
                                                                              attrs: {
                                                                                "document-types":
                                                                                  _vm.certificationDocumentTypes,
                                                                                readonly: !_vm.isPreliminar
                                                                              },
                                                                              on: {
                                                                                "add-document": function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.certVisitUploadDocument(
                                                                                    item,
                                                                                    index
                                                                                  )
                                                                                },
                                                                                cancel: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.openCertificationVisit(
                                                                                    item,
                                                                                    index
                                                                                  )
                                                                                },
                                                                                "download-document":
                                                                                  _vm.onDownload
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.certDocument,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "certDocument",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.certDocument"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              item.transactionType ==
                                                                1 ||
                                                              item.transactionType ==
                                                                _vm
                                                                  .billingLevelEnum
                                                                  .educational
                                                                ? _c(
                                                                    "custom-tab-item",
                                                                    {
                                                                      key: "2",
                                                                      attrs: {
                                                                        active:
                                                                          _vm.visitDetailsTabIndex ===
                                                                          2,
                                                                        lazy:
                                                                          "",
                                                                        title:
                                                                          "Detalles de Visita"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.viewVisitDetailHandler(
                                                                            item,
                                                                            index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      item.details &&
                                                                      item
                                                                        .details
                                                                        .visitDetailsList
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "pb-4"
                                                                            },
                                                                            [
                                                                              _vm._l(
                                                                                item
                                                                                  .details
                                                                                  .visitDetailsList
                                                                                  .data,
                                                                                function(
                                                                                  visitItem,
                                                                                  visitIndex
                                                                                ) {
                                                                                  return _c(
                                                                                    "div",
                                                                                    {
                                                                                      key: `visit-details_${visitIndex}`,
                                                                                      staticClass:
                                                                                        "row mx-0 mx-md-4 mx-sm-0 p-3 border-bottom"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-md-2"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-gray-6"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " Fecha: "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-black"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    _vm.$formatDate(
                                                                                                      visitItem.visitDate,
                                                                                                      _vm
                                                                                                        .$templateDate
                                                                                                        .default
                                                                                                    )
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-md-3 mt-3 mt-md-0 mt-sm-3"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-gray-6"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " Horario: "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-black"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    visitItem.completeTime
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-md-2 mt-3 mt-md-0 mt-sm-3"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-gray-6"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " Tipo de Visita: "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-black"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    visitItem.visitTypeName
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-md-5"
                                                                                        },
                                                                                        [
                                                                                          _vm.isEducativeService(
                                                                                            item.disciplineTypeCd
                                                                                          )
                                                                                            ? _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-black"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    [
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "font-14 color-gray-6"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            " Maestro: "
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " " +
                                                                                                          _vm._s(
                                                                                                            visitItem.visitSpecialistName
                                                                                                          ) +
                                                                                                          " "
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    [
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "font-14 color-gray-6"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            " Asistente: "
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " " +
                                                                                                          _vm._s(
                                                                                                            visitItem.assistanceServiceSpecialistName
                                                                                                          ) +
                                                                                                          " "
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            : _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-14 color-black"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "font-14 color-gray-6"
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        " Especialista: "
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " " +
                                                                                                      _vm._s(
                                                                                                        visitItem.visitSpecialistName
                                                                                                      ) +
                                                                                                      " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        " " +
                                                                                                          _vm._s(
                                                                                                            visitItem.locationService
                                                                                                          ) +
                                                                                                          " "
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              item
                                                                                .details
                                                                                .visitDetailsList &&
                                                                              item
                                                                                .details
                                                                                .visitDetailsList
                                                                                .data &&
                                                                              item
                                                                                .details
                                                                                .visitDetailsList
                                                                                .pagination
                                                                                .totalItemCount >
                                                                                _vm.getVisitDetailsPaginationSize
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mx-4"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "pagination",
                                                                                        {
                                                                                          attrs: {
                                                                                            data:
                                                                                              item
                                                                                                .details
                                                                                                .visitDetailsList
                                                                                                .pagination,
                                                                                            "parent-id":
                                                                                              "visit-details",
                                                                                            "show-text":
                                                                                              ""
                                                                                          },
                                                                                          on: {
                                                                                            "pagination-go-page": function(
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.goToPageHandlerVisitDetails(
                                                                                                $event,
                                                                                                item,
                                                                                                index
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                : _vm._e()
                                                                            ],
                                                                            2
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm.enableBillingAdjustment &&
                                                              _vm.canDoAjustToBill
                                                                ? _c(
                                                                    "custom-tab-item",
                                                                    {
                                                                      key: "3",
                                                                      attrs: {
                                                                        active:
                                                                          _vm.visitDetailsTabIndex ===
                                                                          3,
                                                                        title:
                                                                          "Ajustes"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.viewBillingAdjusment(
                                                                            item,
                                                                            index,
                                                                            true
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "validation-observer",
                                                                        {
                                                                          ref:
                                                                            "adjustmentFormRef",
                                                                          refInFor: true,
                                                                          attrs: {
                                                                            novalidate:
                                                                              "",
                                                                            tag:
                                                                              "form"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "px-3"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-md-3"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-gray-6 mb-1"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " Nivel: "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "bg-gray-9 p-2 rounded"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "validation-provider",
                                                                                                {
                                                                                                  attrs: {
                                                                                                    rules:
                                                                                                      "required"
                                                                                                  },
                                                                                                  scopedSlots: _vm._u(
                                                                                                    [
                                                                                                      {
                                                                                                        key:
                                                                                                          "default",
                                                                                                        fn: function({
                                                                                                          errors
                                                                                                        }) {
                                                                                                          return [
                                                                                                            _c(
                                                                                                              "custom-radio",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "custom-radio__extended",
                                                                                                                attrs: {
                                                                                                                  id: `rbtn-level-${Math.random()}`,
                                                                                                                  "change-event":
                                                                                                                    _vm.onChangeLevel,
                                                                                                                  "custom-error-msg":
                                                                                                                    "Favor seleccione",
                                                                                                                  error: Boolean(
                                                                                                                    errors[0]
                                                                                                                  ),
                                                                                                                  "is-inline":
                                                                                                                    "",
                                                                                                                  name:
                                                                                                                    "rbAdjustLevel",
                                                                                                                  options: _vm.getLevelOptions(
                                                                                                                    item.transactionType
                                                                                                                  ),
                                                                                                                  type:
                                                                                                                    "questions"
                                                                                                                },
                                                                                                                model: {
                                                                                                                  value:
                                                                                                                    _vm.adjustmentLevelSelected,
                                                                                                                  callback: function(
                                                                                                                    $$v
                                                                                                                  ) {
                                                                                                                    _vm.adjustmentLevelSelected = $$v
                                                                                                                  },
                                                                                                                  expression:
                                                                                                                    "\n                                                adjustmentLevelSelected\n                                              "
                                                                                                                }
                                                                                                              }
                                                                                                            )
                                                                                                          ]
                                                                                                        }
                                                                                                      }
                                                                                                    ],
                                                                                                    null,
                                                                                                    true
                                                                                                  )
                                                                                                }
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm.canViewVisitDate(
                                                                                        item
                                                                                      )
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-md-3"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "font-14 color-gray-6 mb-1"
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        " Fecha de Visita: "
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "validation-provider",
                                                                                                    {
                                                                                                      attrs: {
                                                                                                        rules:
                                                                                                          "required"
                                                                                                      },
                                                                                                      scopedSlots: _vm._u(
                                                                                                        [
                                                                                                          {
                                                                                                            key:
                                                                                                              "default",
                                                                                                            fn: function({
                                                                                                              errors
                                                                                                            }) {
                                                                                                              return [
                                                                                                                _c(
                                                                                                                  "custom-drop-down",
                                                                                                                  {
                                                                                                                    attrs: {
                                                                                                                      clearable: false,
                                                                                                                      "custom-error-msg":
                                                                                                                        "Favor de seleccionar la visita.",
                                                                                                                      error:
                                                                                                                        errors[0],
                                                                                                                      fieldkey:
                                                                                                                        "id",
                                                                                                                      fieldname:
                                                                                                                        "name",
                                                                                                                      options:
                                                                                                                        _vm.visits,
                                                                                                                      placeholder:
                                                                                                                        "Seleccione"
                                                                                                                    },
                                                                                                                    model: {
                                                                                                                      value:
                                                                                                                        _vm.adjustmentVisit,
                                                                                                                      callback: function(
                                                                                                                        $$v
                                                                                                                      ) {
                                                                                                                        _vm.adjustmentVisit = $$v
                                                                                                                      },
                                                                                                                      expression:
                                                                                                                        "adjustmentVisit"
                                                                                                                    }
                                                                                                                  }
                                                                                                                )
                                                                                                              ]
                                                                                                            }
                                                                                                          }
                                                                                                        ],
                                                                                                        null,
                                                                                                        true
                                                                                                      )
                                                                                                    }
                                                                                                  )
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-md-6",
                                                                                          class: {
                                                                                            "col-md-9": !_vm.canViewVisitDate(
                                                                                              item
                                                                                            )
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-gray-6 mb-1"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " Razón: "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "validation-provider",
                                                                                            {
                                                                                              attrs: {
                                                                                                rules:
                                                                                                  "required"
                                                                                              },
                                                                                              scopedSlots: _vm._u(
                                                                                                [
                                                                                                  {
                                                                                                    key:
                                                                                                      "default",
                                                                                                    fn: function({
                                                                                                      errors
                                                                                                    }) {
                                                                                                      return [
                                                                                                        _c(
                                                                                                          "custom-drop-down",
                                                                                                          {
                                                                                                            attrs: {
                                                                                                              clearable: false,
                                                                                                              "custom-error-msg":
                                                                                                                "Favor seleccionar razón del ajuste.",
                                                                                                              error:
                                                                                                                errors[0],
                                                                                                              fieldkey:
                                                                                                                "id",
                                                                                                              fieldname:
                                                                                                                "name",
                                                                                                              options:
                                                                                                                _vm.reasons,
                                                                                                              placeholder:
                                                                                                                "Seleccione"
                                                                                                            },
                                                                                                            on: {
                                                                                                              input:
                                                                                                                _vm.onReasonChange
                                                                                                            },
                                                                                                            model: {
                                                                                                              value:
                                                                                                                _vm.adjustmentReasonId,
                                                                                                              callback: function(
                                                                                                                $$v
                                                                                                              ) {
                                                                                                                _vm.adjustmentReasonId = $$v
                                                                                                              },
                                                                                                              expression:
                                                                                                                "adjustmentReasonId"
                                                                                                            }
                                                                                                          }
                                                                                                        )
                                                                                                      ]
                                                                                                    }
                                                                                                  }
                                                                                                ],
                                                                                                null,
                                                                                                true
                                                                                              )
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-md-3 mt-3"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-gray-6 mb-1"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " Cantidad: "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "validation-provider",
                                                                                            {
                                                                                              attrs: {
                                                                                                rules:
                                                                                                  "required"
                                                                                              },
                                                                                              scopedSlots: _vm._u(
                                                                                                [
                                                                                                  {
                                                                                                    key:
                                                                                                      "default",
                                                                                                    fn: function({
                                                                                                      errors
                                                                                                    }) {
                                                                                                      return [
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "input-group mb-3"
                                                                                                          },
                                                                                                          [
                                                                                                            _c(
                                                                                                              "div",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "input-amount-dollar"
                                                                                                              },
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "em",
                                                                                                                  {
                                                                                                                    staticClass:
                                                                                                                      "fa fa-dollar-sign"
                                                                                                                  }
                                                                                                                )
                                                                                                              ]
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "custom-input",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "w-50",
                                                                                                                attrs: {
                                                                                                                  "custom-error-msg":
                                                                                                                    "",
                                                                                                                  error:
                                                                                                                    errors[0],
                                                                                                                  type:
                                                                                                                    "number"
                                                                                                                },
                                                                                                                model: {
                                                                                                                  value:
                                                                                                                    _vm.adjustmentQuantity,
                                                                                                                  callback: function(
                                                                                                                    $$v
                                                                                                                  ) {
                                                                                                                    _vm.adjustmentQuantity = $$v
                                                                                                                  },
                                                                                                                  expression:
                                                                                                                    "adjustmentQuantity"
                                                                                                                }
                                                                                                              }
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "div",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "input-amount-action"
                                                                                                              },
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "em",
                                                                                                                  {
                                                                                                                    staticClass:
                                                                                                                      "fa fa-plus-circle",
                                                                                                                    on: {
                                                                                                                      click: function(
                                                                                                                        $event
                                                                                                                      ) {
                                                                                                                        return _vm.onChangeAmountSign(
                                                                                                                          "positive"
                                                                                                                        )
                                                                                                                      }
                                                                                                                    }
                                                                                                                  }
                                                                                                                ),
                                                                                                                _c(
                                                                                                                  "em",
                                                                                                                  {
                                                                                                                    staticClass:
                                                                                                                      "fa fa-minus-circle",
                                                                                                                    on: {
                                                                                                                      click: function(
                                                                                                                        $event
                                                                                                                      ) {
                                                                                                                        return _vm.onChangeAmountSign(
                                                                                                                          "negative"
                                                                                                                        )
                                                                                                                      }
                                                                                                                    }
                                                                                                                  }
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ],
                                                                                                          1
                                                                                                        ),
                                                                                                        errors[0]
                                                                                                          ? _c(
                                                                                                              "error",
                                                                                                              {
                                                                                                                attrs: {
                                                                                                                  message:
                                                                                                                    "Cantidad del ajuste es requerida.",
                                                                                                                  variant:
                                                                                                                    "no-border mt-n3"
                                                                                                                }
                                                                                                              }
                                                                                                            )
                                                                                                          : _vm._e()
                                                                                                      ]
                                                                                                    }
                                                                                                  }
                                                                                                ],
                                                                                                null,
                                                                                                true
                                                                                              )
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-md-9 mt-3"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "font-14 color-gray-6 mb-1"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " Comentario: "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "validation-provider",
                                                                                            {
                                                                                              attrs: {
                                                                                                rules:
                                                                                                  "required"
                                                                                              },
                                                                                              scopedSlots: _vm._u(
                                                                                                [
                                                                                                  {
                                                                                                    key:
                                                                                                      "default",
                                                                                                    fn: function({
                                                                                                      errors
                                                                                                    }) {
                                                                                                      return [
                                                                                                        _c(
                                                                                                          "custom-input",
                                                                                                          {
                                                                                                            attrs: {
                                                                                                              "custom-error-msg":
                                                                                                                "Comentario es requerido para registrar el ajuste.",
                                                                                                              error:
                                                                                                                errors[0]
                                                                                                            },
                                                                                                            model: {
                                                                                                              value:
                                                                                                                _vm.adjustmentComment,
                                                                                                              callback: function(
                                                                                                                $$v
                                                                                                              ) {
                                                                                                                _vm.adjustmentComment = $$v
                                                                                                              },
                                                                                                              expression:
                                                                                                                "adjustmentComment"
                                                                                                            }
                                                                                                          }
                                                                                                        )
                                                                                                      ]
                                                                                                    }
                                                                                                  }
                                                                                                ],
                                                                                                null,
                                                                                                true
                                                                                              )
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col my-3 text-right"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "action-button",
                                                                                            {
                                                                                              attrs: {
                                                                                                i:
                                                                                                  "fa fa-save",
                                                                                                variant:
                                                                                                  "success pl-4 pr-4"
                                                                                              },
                                                                                              on: {
                                                                                                click: function(
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.saveItemAdjustment(
                                                                                                    item,
                                                                                                    index
                                                                                                  )
                                                                                                }
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " Guardar "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "hr",
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-n1 mb-3"
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "row"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "col"
                                                                                    },
                                                                                    _vm._l(
                                                                                      item
                                                                                        .details
                                                                                        .billingAdjustmentDetails,
                                                                                      function(
                                                                                        reasonItem,
                                                                                        reasonIndex
                                                                                      ) {
                                                                                        return _c(
                                                                                          "custom-callout",
                                                                                          {
                                                                                            key:
                                                                                              "adjustment-reason" +
                                                                                              reasonIndex,
                                                                                            staticClass:
                                                                                              "mb-3",
                                                                                            attrs: {
                                                                                              "has-toggle": false
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "row"
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "col-md-2 col-sm-12 col-spacing student-spacing"
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "font-14 color-gray-6"
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " Nivel: "
                                                                                                        )
                                                                                                      ]
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "color-black"
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              _vm.getTransactionName(
                                                                                                                reasonItem
                                                                                                              )
                                                                                                            ) +
                                                                                                            " "
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                !reasonItem.adjustmentDate
                                                                                                  ? _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "col-md-6 col-sm-12 col-spacing student-spacing"
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "font-14 color-gray-6"
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " Razón: "
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "color-black font-weight-normal"
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " " +
                                                                                                                _vm._s(
                                                                                                                  reasonItem.adjustmentReasonDescription
                                                                                                                ) +
                                                                                                                " "
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                                reasonItem.adjustmentDate
                                                                                                  ? _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "col-md-6 col-sm-12 col-spacing student-spacing"
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "font-14 color-gray-6"
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " Fecha de visita: "
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "color-black font-weight-normal"
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " " +
                                                                                                                _vm._s(
                                                                                                                  _vm.$formatDate(
                                                                                                                    reasonItem.adjustmentDate,
                                                                                                                    _vm
                                                                                                                      .$templateDate
                                                                                                                      .default
                                                                                                                  )
                                                                                                                ) +
                                                                                                                " "
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                                _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "col-md-2 col-sm-12 col-spacing student-spacing"
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "font-14 color-gray-6"
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " Cantidad: "
                                                                                                        )
                                                                                                      ]
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "color-black font-weight-normal"
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              _vm._f(
                                                                                                                "price"
                                                                                                              )(
                                                                                                                reasonItem.adjustmentAmt
                                                                                                              )
                                                                                                            ) +
                                                                                                            " "
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "col-md-2 mt-3 text-right"
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "action-button",
                                                                                                      {
                                                                                                        attrs: {
                                                                                                          i:
                                                                                                            "fas fa-minus-circle",
                                                                                                          variant:
                                                                                                            "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                                                                                        },
                                                                                                        on: {
                                                                                                          click: function(
                                                                                                            $event
                                                                                                          ) {
                                                                                                            return _vm.onDeleteBillingAdjustment(
                                                                                                              item,
                                                                                                              reasonItem,
                                                                                                              index
                                                                                                            )
                                                                                                          }
                                                                                                        }
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " Eliminar "
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ],
                                                                                                  1
                                                                                                ),
                                                                                                reasonItem.comments
                                                                                                  ? _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "col-md-12 mt-n3 mb-3"
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "hr"
                                                                                                        ),
                                                                                                        reasonItem.adjustmentReasonDescription &&
                                                                                                        reasonItem.adjustmentDate
                                                                                                          ? _c(
                                                                                                              "div",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "mb-3"
                                                                                                              },
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "div",
                                                                                                                  {
                                                                                                                    staticClass:
                                                                                                                      "font-14 color-gray-6"
                                                                                                                  },
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      " Razón: "
                                                                                                                    )
                                                                                                                  ]
                                                                                                                ),
                                                                                                                _c(
                                                                                                                  "div",
                                                                                                                  {
                                                                                                                    staticClass:
                                                                                                                      "color-black font-weight-normal"
                                                                                                                  },
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      " " +
                                                                                                                        _vm._s(
                                                                                                                          reasonItem.adjustmentReasonDescription
                                                                                                                        ) +
                                                                                                                        " "
                                                                                                                    )
                                                                                                                  ]
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          : _vm._e(),
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "font-14 color-gray-6 mb-1"
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " Comentario: "
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "color-black"
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " " +
                                                                                                                _vm._s(
                                                                                                                  reasonItem.comments
                                                                                                                ) +
                                                                                                                " "
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  : _vm._e()
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      }
                                                                                    ),
                                                                                    1
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _vm.isEducativeService(
                                                                item.disciplineTypeCd
                                                              )
                                                                ? _c(
                                                                    "custom-tab-item",
                                                                    {
                                                                      key: "4",
                                                                      staticClass:
                                                                        "pb-4",
                                                                      attrs: {
                                                                        active:
                                                                          _vm.visitDetailsTabIndex ===
                                                                          4,
                                                                        lazy:
                                                                          "",
                                                                        title:
                                                                          "Documentos de Propuesta"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.openServiceProposal(
                                                                            item,
                                                                            index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "educative-service-document-management",
                                                                        {
                                                                          attrs: {
                                                                            "request-id": _vm.getAdditionalInfoIdByTransactionType(
                                                                              item
                                                                            )
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _vm.showRetroactivePaymentsTab(
                                                                item
                                                              )
                                                                ? _c(
                                                                    "custom-tab-item",
                                                                    {
                                                                      attrs: {
                                                                        active:
                                                                          _vm.visitDetailsTabIndex ===
                                                                          7,
                                                                        "content-class":
                                                                          "mt-3 pb-3",
                                                                        title:
                                                                          "Consulta de Pagos Retroactivos"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onChangeToAdittionalInfo(
                                                                            item,
                                                                            index,
                                                                            _vm
                                                                              .billingServiceTabs
                                                                              .RETROACTIVE_PAYMENTS
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "retroactive-payments",
                                                                        {
                                                                          attrs: {
                                                                            readonly: true,
                                                                            value: _vm.getRetroactivePaymentsDetails(
                                                                              item
                                                                            )
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              item.isEducativeService
                                                                ? _c(
                                                                    "tab-service-detail",
                                                                    {
                                                                      attrs: {
                                                                        active:
                                                                          _vm.visitDetailsTabIndex ===
                                                                          5,
                                                                        detail:
                                                                          _vm.serviceDetail,
                                                                        disable: !_vm.isPreliminar
                                                                      },
                                                                      on: {
                                                                        getServiceDetail: () =>
                                                                          _vm.getEducationalServiceDetails(
                                                                            item.id
                                                                          ),
                                                                        update: (
                                                                          service,
                                                                          isRemoving
                                                                        ) =>
                                                                          _vm.updateEducationalService(
                                                                            item,
                                                                            service,
                                                                            isRemoving
                                                                          )
                                                                      }
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                              item.isEducativeService
                                                                ? _c(
                                                                    "tab-service-summary",
                                                                    {
                                                                      attrs: {
                                                                        active:
                                                                          _vm.visitDetailsTabIndex ===
                                                                          6,
                                                                        detail:
                                                                          _vm.servicesSummary
                                                                      },
                                                                      on: {
                                                                        getServiceSummary: () =>
                                                                          _vm.getEducationalServicesSumarry(
                                                                            item.tapRequestId
                                                                          )
                                                                      }
                                                                    }
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 col-sm-12 col-spacing student-spacing"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "legend" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.evaluationTypeName ||
                                                          item.serviceTypeName
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-normal color-black"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.disciplineName
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 col-sm-12 col-spacing service-place-spacing"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "legend" },
                                                [_vm._v(" Estudiante: ")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-normal color-black"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.emptyText(
                                                          item.studentName
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-1 col-sm-12 col-spacing"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "legend" },
                                                [_vm._v(" SIE: ")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-normal color-black"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.emptyText(
                                                          item.studentSieId
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 col-sm-12 col-spacing"
                                            },
                                            [
                                              item.isEducativeService
                                                ? _c(
                                                    "div",
                                                    { staticClass: "legend" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.isForAssistanceServiceFlag ===
                                                              true
                                                              ? "Asistente de Servicio:"
                                                              : "Maestro:"
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    { staticClass: "legend" },
                                                    [_vm._v(" Especialista: ")]
                                                  ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-normal color-black"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.fullName) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-1 col-sm-12 col-spacing"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "legend" },
                                                [_vm._v(" Conteo: ")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-normal color-black"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.emptyText(
                                                          item.recordCount
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-12 col-spacing",
                                              class: {
                                                "col-md-1": item.isElegible,
                                                "col-md-2": !item.isElegible
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "legend" },
                                                [_vm._v(" Costo: ")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-normal color-black"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("price")(
                                                          item.costAmount +
                                                            item.educationServiceCostAmount
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          item.isElegible
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-1 col-sm-12 col-spacing"
                                                },
                                                [
                                                  _c("badge", {
                                                    attrs: {
                                                      text: "Elegible",
                                                      value: item.isElegible
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 col-sm-12 col-spacing text-right pt-4"
                                            },
                                            [
                                              _vm.enableBillingAdjustment
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-around"
                                                    },
                                                    [
                                                      _vm.canDownloadDocument &&
                                                      !_vm.isConsultingService(
                                                        item
                                                      )
                                                        ? _c("action-button", {
                                                            staticClass:
                                                              "custom-print-button",
                                                            attrs: {
                                                              i:
                                                                "fas fa-download",
                                                              variant:
                                                                "outline-success"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.evaluateDownload(
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm.isConsultingService(
                                                        item
                                                      )
                                                        ? _c("action-button", {
                                                            staticClass:
                                                              "custom-print-button",
                                                            attrs: {
                                                              i:
                                                                "far fa-search-plus",
                                                              variant:
                                                                "outline-success"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.viewVisitDetailHandler(
                                                                  item,
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm.canMarkAsIntervened
                                                        ? _c("action-button", {
                                                            staticClass:
                                                              "custom-flag-button d-flex justify-content-center align-items-center px-1",
                                                            attrs: {
                                                              i:
                                                                "far fa-flag pl-0 mx-2",
                                                              variant: item.checkedFlag
                                                                ? "success"
                                                                : "outline-success"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.checkUncheckService(
                                                                  item,
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _c(
                                                        "div",
                                                        [
                                                          _c("action-button", {
                                                            staticClass:
                                                              "custom-print-button",
                                                            attrs: {
                                                              "aria-expanded":
                                                                "false",
                                                              "aria-haspopup":
                                                                "true",
                                                              "data-toggle":
                                                                "dropdown",
                                                              i:
                                                                "fas fa-ellipsis-h",
                                                              variant:
                                                                "outline-success"
                                                            }
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "dropdown-menu dropdown-menu-right custom-dropdown-container",
                                                              attrs: {
                                                                "aria-labelledby":
                                                                  "dropdownMenuButton"
                                                              }
                                                            },
                                                            [
                                                              _vm.isEvaluationService(
                                                                item
                                                              ) == false
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item cursor-pointer mb-1",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.viewVisitDetailHandler(
                                                                            item,
                                                                            index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("em", {
                                                                        staticClass:
                                                                          "fa fa-file-search text-green pr-1"
                                                                      }),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Detalle Visita"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm.isEvaluationService(
                                                                item
                                                              ) == false
                                                                ? _c("hr", {
                                                                    staticClass:
                                                                      "mt-2"
                                                                  })
                                                                : _vm._e(),
                                                              _vm.canDoAjustToBill
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item cursor-pointer mt-n2",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.viewBillingAdjusment(
                                                                            item,
                                                                            index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("em", {
                                                                        staticClass:
                                                                          "fa fa-cog text-green pr-1"
                                                                      }),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "ml-1"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Ajustar"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              !_vm.isDirectorCentro &&
                                              _vm.userHasPermissions(
                                                "provider.bill.admissionnote.view"
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown d-flex justify-content-end align-items-center mt-3 mr-3"
                                                    },
                                                    [
                                                      _vm.isAdditionalInfoTypeConsulting(
                                                        item.transactionType
                                                      )
                                                        ? _c("action-button", {
                                                            staticClass:
                                                              "custom-print-button",
                                                            attrs: {
                                                              i:
                                                                "fas fa-download",
                                                              variant:
                                                                "outline-success mr-3"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.downloadConsultingDocument(
                                                                  item.id
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-dropdown-actions dropdown-toggle float-right",
                                                          attrs: {
                                                            id:
                                                              "dropdownMenuButton",
                                                            "aria-expanded":
                                                              "false",
                                                            "aria-haspopup":
                                                              "true",
                                                            "data-toggle":
                                                              "dropdown",
                                                            type: "button"
                                                          }
                                                        },
                                                        [_vm._v(" Acciones ")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dropdown-menu dropdown-menu-right custom-dropdown-container",
                                                          attrs: {
                                                            "aria-labelledby":
                                                              "dropdownMenuButton"
                                                          }
                                                        },
                                                        [
                                                          item.transactionType ==
                                                            _vm.billingLevelEnum
                                                              .visit ||
                                                          item.transactionType ==
                                                            _vm.billingLevelEnum
                                                              .educational
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "dropdown-item cursor-pointer mb-1",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.viewVisitDetailHandler(
                                                                        item,
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("em", {
                                                                    staticClass:
                                                                      "fa fa-file-search text-green pr-1"
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Ver Detalle Visita"
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          item.transactionType ==
                                                            _vm.billingLevelEnum
                                                              .educational &&
                                                          !_vm.isPreliminar
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "dropdown-item cursor-pointer mb-1",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.openEducationalServiceTab(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("em", {
                                                                    staticClass:
                                                                      "fa fa-file-search text-green pr-1"
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Ver detalle de Servicios"
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm.canEditVist(
                                                            item
                                                          ) &&
                                                          _vm.isVisitType(
                                                            item
                                                          ) &&
                                                          _vm.isPreliminar
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "dropdown-item cursor-pointer",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.editVisitHandler(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("em", {
                                                                    staticClass:
                                                                      "fa fa-file-edit text-green pr-1"
                                                                  }),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "ml-2"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.editVisitTitle(
                                                                              item
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          !item.isPlanSubmitted &&
                                                          _vm.showPlanDownload(
                                                            item.disciplineTypeCd
                                                          ) &&
                                                          item.transactionType ===
                                                            _vm.billingLevelEnum
                                                              .visit
                                                            ? _c("div", [
                                                                _c("hr", {
                                                                  staticClass:
                                                                    "mt-2"
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "dropdown-item cursor-pointer mt-n2",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onPlanInterventionRevisionDownload(
                                                                          item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("em", {
                                                                      staticClass:
                                                                        "fa fa-file-search text-green pr-1"
                                                                    }),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Descargar Plan"
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          item.isPlanSubmitted
                                                            ? _c("div", [
                                                                _c("hr", {
                                                                  staticClass:
                                                                    "mt-2"
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "dropdown-item cursor-pointer mt-n2",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.ViewPlanHandler(
                                                                          item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("em", {
                                                                      staticClass:
                                                                        "fa fa-file-search text-green pr-1"
                                                                    }),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Ver Plan"
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          item.isAdmissionRecord &&
                                                          _vm.userHasPermissions(
                                                            "provider.bill.admissionnote.view"
                                                          )
                                                            ? _c("div", [
                                                                _c("hr", {
                                                                  staticClass:
                                                                    "mt-2"
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "dropdown-item cursor-pointer mt-n2",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.viewAdmissionDetail(
                                                                          item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("em", {
                                                                      staticClass:
                                                                        "fa fa-file-search text-green pr-1"
                                                                    }),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Ver Nota de Admisión"
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          (_vm.isUserProvider ||
                                                            _vm.isAdminProvider) &&
                                                          _vm.isThrpyService(
                                                            item
                                                          ) &&
                                                          item.transactionType ==
                                                            1
                                                            ? _c("div", [
                                                                _c("hr", {
                                                                  staticClass:
                                                                    "mt-2"
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "dropdown-item cursor-pointer mt-n2",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.openCertificationVisit(
                                                                          item,
                                                                          index
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("em", {
                                                                      staticClass:
                                                                        "fa fa-file-plus text-green pr-1"
                                                                    }),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Certificación de Visita "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          _vm.isEducativeService(
                                                            item.disciplineTypeCd
                                                          )
                                                            ? _c("div", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "dropdown-item cursor-pointer mt-2",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.openServiceProposal(
                                                                          item,
                                                                          index
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("em", {
                                                                      staticClass:
                                                                        "fa fa-file-download text-green pr-1"
                                                                    }),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Documentos de Propuesta "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          item.transactionType ==
                                                          2
                                                            ? _c("div", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "dropdown-item cursor-pointer mb-1",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onEvaluationAppointmentDownload(
                                                                          item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("em", {
                                                                      staticClass:
                                                                        "fa fa-file-search text-green pr-1"
                                                                    }),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Descargar Evaluación"
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]),
                                        _c(
                                          "validation-observer",
                                          {
                                            ref: "purchaseOrders",
                                            refInFor: true,
                                            attrs: {
                                              novalidate: "",
                                              tag: "form"
                                            }
                                          },
                                          [
                                            _vm.viewBillingAdjustment
                                              ? _c(
                                                  "additional-purchase-order",
                                                  {
                                                    attrs: {
                                                      "additional-info":
                                                        _vm.pagination.data[
                                                          index
                                                        ],
                                                      "bill-status":
                                                        _vm.billModel.statusId,
                                                      "is-federal-number":
                                                        _vm.isFederalNumber,
                                                      "purchase-orders":
                                                        _vm.purchaseOrdersByCompany,
                                                      value:
                                                        _vm.pagination.data[
                                                          index
                                                        ].purchaseOrder
                                                    },
                                                    on: {
                                                      save: function($event) {
                                                        return _vm.saveNumber(
                                                          item,
                                                          index
                                                        )
                                                      },
                                                      update: value =>
                                                        (_vm.pagination.data[
                                                          index
                                                        ].purchaseOrder = value)
                                                    }
                                                  }
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    item.isEducativeService &&
                                    !item.isOpen &&
                                    _vm.isPreliminar
                                      ? _c(
                                          "section",
                                          { staticClass: "educative-info" },
                                          [
                                            _c("div", [
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-file-invoice-dollar"
                                                }),
                                                _vm._v(
                                                  " Cuenta con servicios disponibles para facturar. Presione "
                                                ),
                                                _c(
                                                  "label",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openEducationalServiceTab(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" aquí ")]
                                                ),
                                                _vm._v(" para comenzar. ")
                                              ])
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.hasEducationEvaluation(item)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "service-warning-container"
                                          },
                                          [
                                            _c("error", {
                                              attrs: {
                                                "is-alert-mode": "",
                                                message:
                                                  "La evaluación Psicoeducativa fue identificada como Educativa al completar la misma. (R03200001)",
                                                variant: "no-border"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              (this.pagination.data || []).length == 0
                                ? _c("custom-result-not-found")
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm.pagination.data.length > 0 &&
                      _vm.pagination.totalItemCount > _vm.pagination.count
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-1 pt-4" },
                              [
                                _c("custom-drop-down", {
                                  attrs: {
                                    clearable: false,
                                    fieldkey: "id",
                                    fieldname: "name",
                                    options: _vm.pagingList
                                  },
                                  on: { input: _vm.onSelectedPagingHandler },
                                  model: {
                                    value: _vm.selectedPaging,
                                    callback: function($$v) {
                                      _vm.selectedPaging = $$v
                                    },
                                    expression: "selectedPaging"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-11" },
                              [
                                _c("pagination", {
                                  attrs: {
                                    data: _vm.pagination,
                                    "page-size": _vm.pageSize,
                                    "show-input-to-go": true,
                                    "show-text": ""
                                  },
                                  on: {
                                    "pagination-go-page":
                                      _vm.setCurrentDetailPage
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "custom-tab-item",
                    {
                      staticClass: "mb-5",
                      attrs: {
                        active:
                          _vm.billingInfoTabIndex ===
                          _vm.billingInfoTabs.DOCUMENTS,
                        lazy: "",
                        title: "Documentos"
                      },
                      on: {
                        click: () => {
                          this.onChangeInfoTab(_vm.billingInfoTabs.DOCUMENTS)
                          this.getBillingDocuments()
                        }
                      }
                    },
                    [
                      _vm.invoiceDocuments.length == 0 && !_vm.addingDocument
                        ? _c(
                            "callout",
                            {
                              attrs: {
                                "class-main": "py-3",
                                "has-toggle": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row d-flex justify-content-center"
                                },
                                [
                                  _vm.enableDocumentAdd
                                    ? _c("action-button", {
                                        staticClass: "border w-40 btn",
                                        attrs: {
                                          i: "fas fa-file-plus color-primary-1",
                                          text:
                                            "Presione aquí para anejar documentos"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.addingDocument = !_vm.addingDocument
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._l(_vm.invoiceDocuments, function(
                        invoiceDocItem,
                        invoiceDocIndex
                      ) {
                        return _c(
                          "custom-callout",
                          {
                            key: "invoice-document" + invoiceDocIndex,
                            staticClass: "mb-3 custom-callout",
                            attrs: { "has-toggle": false }
                          },
                          [
                            _c("div", { staticClass: "row mx-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-4 col-sm-12 col-spacing student-spacing"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "font-14 color-gray-6" },
                                    [_vm._v(" Tipo de Documento: ")]
                                  ),
                                  _c("div", { staticClass: "color-black" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(invoiceDocItem.documentType) +
                                        " "
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-4 col-sm-12 col-spacing student-spacing"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "font-14 color-gray-6" },
                                    [_vm._v(" Archivo: ")]
                                  ),
                                  _c("div", { staticClass: "color-black" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(invoiceDocItem.fileName) +
                                        " "
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mt-3" },
                                [
                                  _c("drop-down", {
                                    staticClass:
                                      "d-flex justify-content-end dropdown-doc__extended",
                                    attrs: {
                                      "data-item": {
                                        value: invoiceDocItem,
                                        index: invoiceDocIndex
                                      },
                                      items: _vm.actionItems()
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      }),
                      _vm.invoiceDocuments.length > 0 &&
                      _vm.billingDocumentTypes.length > 0 &&
                      !_vm.addingDocument &&
                      _vm.enableDocumentAdd
                        ? _c(
                            "div",
                            { staticClass: "col text-right" },
                            [
                              _c("action-button", {
                                attrs: {
                                  i: "fas fa-file-plus",
                                  text: "Añadir",
                                  variant: "success"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.addingDocument = !_vm.addingDocument
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.addingDocument
                        ? _c(
                            "custom-callout",
                            {
                              staticClass: "mb-3 ml-2 custom-callout",
                              attrs: { "has-toggle": false }
                            },
                            [
                              _c(
                                "validation-observer",
                                {
                                  ref: "addBillingDocument",
                                  attrs: { novalidate: "", tag: "form" }
                                },
                                [
                                  _c("div", { staticClass: "row mx-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 pt-3 pb-3" },
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-drop-down", {
                                                      attrs: {
                                                        clearable: false,
                                                        "custom-error-msg":
                                                          "Favor de seleccionar el tipo el documento.",
                                                        error: errors[0],
                                                        fieldkey: "id",
                                                        fieldname: "name",
                                                        label:
                                                          "Tipo de Documento:",
                                                        options:
                                                          _vm.notSelectedDocumentTypes,
                                                        placeholder:
                                                          "Seleccione"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.documentModel
                                                            .type,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.documentModel,
                                                            "type",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "documentModel.type"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            4292882078
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 pt-3 pb-3" },
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-14 color-gray-6"
                                                      },
                                                      [_vm._v(" Archivo: ")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-14 color-black mt-2"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-align-items-center"
                                                          },
                                                          [
                                                            _c(
                                                              "custom-file-input",
                                                              {
                                                                ref:
                                                                  "billinAttachedDocument",
                                                                attrs: {
                                                                  accept:
                                                                    _vm.acceptedExtension,
                                                                  "attachment-id":
                                                                    _vm
                                                                      .documentModel
                                                                      .selectedDocumentId,
                                                                  "custom-error-msg":
                                                                    "Favor de anejar un documento.",
                                                                  "display-style":
                                                                    "normal",
                                                                  error:
                                                                    errors[0],
                                                                  required: ""
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .documentModel
                                                                      .selectedDocument,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.documentModel,
                                                                      "selectedDocument",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "documentModel.selectedDocument"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            138825071
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-4 pt-3 pb-3 text-right"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "font-14 color-gray-6"
                                          },
                                          [_c("br")]
                                        ),
                                        _c(
                                          "action-button",
                                          {
                                            attrs: {
                                              i: "fas fa-times-circle",
                                              variant:
                                                "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                            },
                                            on: {
                                              click: () => {
                                                _vm.clearDocumentModel()
                                                _vm.addingDocument = !_vm.addingDocument
                                              }
                                            }
                                          },
                                          [_vm._v(" Cancelar ")]
                                        ),
                                        _c(
                                          "action-button",
                                          {
                                            attrs: {
                                              disabled: _vm.disableUpload,
                                              variant: "success pl-4 pr-4"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onUploadBillingDocument(
                                                  _vm.documentModel
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Guardar ")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  !_vm.isPreliminar
                    ? _c(
                        "custom-tab-item",
                        {
                          attrs: {
                            active:
                              _vm.billingInfoTabIndex ===
                              _vm.billingInfoTabs.ADJUSTMENT,
                            lazy: "",
                            title: "Ajustes"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onChangeInfoTab(
                                _vm.billingInfoTabs.ADJUSTMENT
                              )
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "row px-0 px-md-4 px-sm-0" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("total-amount-adjustment-view", {
                                      staticClass: "px-3",
                                      attrs: {
                                        amount: _vm._f("price")(
                                          _vm.adjustmentSummary
                                            .automaticAdjustmentAmount
                                        ),
                                        icon: "fa fa-dollar-sign",
                                        "icon-color": "#2db782",
                                        "service-total":
                                          _vm.adjustmentSummary
                                            .automaticAdjustmentCount ==
                                          undefined
                                            ? 0
                                            : _vm.adjustmentSummary
                                                .automaticAdjustmentCount,
                                        title: "Automáticos"
                                      }
                                    }),
                                    _c("hr", {
                                      staticClass:
                                        "d-block d-md-none d-sm-block"
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col corner-line mt-3 mt-md-0 mt-sm-3"
                                  },
                                  [
                                    _c("total-amount-adjustment-view", {
                                      staticClass: "px-3",
                                      attrs: {
                                        amount: _vm._f("price")(
                                          _vm.adjustmentSummary
                                            .manualAdjustmentAmount
                                        ),
                                        icon: "fa fa-dollar-sign",
                                        "icon-color": "#f8b538",
                                        "service-total":
                                          _vm.adjustmentSummary
                                            .manualAdjustmentCount == undefined
                                            ? 0
                                            : _vm.adjustmentSummary
                                                .manualAdjustmentCount,
                                        title: "Manuales"
                                      }
                                    }),
                                    _c("hr", {
                                      staticClass:
                                        "d-block d-md-none d-sm-block"
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col mt-3 mt-md-0 mt-sm-3" },
                                  [
                                    _c("total-amount-adjustment-view", {
                                      staticClass: "px-3",
                                      attrs: {
                                        amount: _vm._f("price")(
                                          _vm.adjustmentSummary
                                            .totalAdjustmentAmount
                                        ),
                                        icon: "fa fa-dollar-sign",
                                        "icon-color": "#b354c4",
                                        "service-total":
                                          _vm.adjustmentSummary
                                            .totalAdjustmentCount == undefined
                                            ? 0
                                            : _vm.adjustmentSummary
                                                .totalAdjustmentCount,
                                        title: "Total"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c("hr"),
                            _c(
                              "div",
                              { staticClass: "mt-3" },
                              [
                                _c(
                                  "filter-manager",
                                  {
                                    ref: "filterRef",
                                    attrs: {
                                      filters:
                                        _vm.filterManagerAdjustmentConfig,
                                      "search-text": null
                                    },
                                    on: {
                                      adjustment: _vm.onChangeAdjustment,
                                      objected: _vm.onChangeAdjustmentObjected,
                                      sie: _vm.onChangeAdjustmentSie,
                                      status: _vm.onChangeAdjustmentStatus,
                                      type: _vm.onChangeAdjusmentType
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col mt-3 text-right" },
                                      [
                                        _c("br"),
                                        _c("action-button", {
                                          attrs: {
                                            i: "fa fa-search",
                                            text: "Buscar",
                                            variant: "success"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onSearchAdjustmentDetail(
                                                1
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "mt-4" },
                              [
                                _c("icon-view", {
                                  attrs: {
                                    gradient: "",
                                    icon: "fa fa-clipboard-list",
                                    "icon-background": "#FF7058",
                                    "icon-color": "#fff",
                                    title: "Detalle de Ajustes"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("div", { staticClass: "row mt-3" }, [
                              _vm.billingAdjustmentDetailList.data.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    _vm._l(
                                      _vm.billingAdjustmentDetailList.data,
                                      function(item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: `billing_adjustment_detail_${index}`,
                                            staticClass:
                                              "p-3 bg-secondary-3 rounded mb-3"
                                          },
                                          [
                                            _c(
                                              "validation-observer",
                                              {
                                                ref: "billingObjectionFormRef",
                                                refInFor: true,
                                                attrs: {
                                                  novalidate: "",
                                                  tag: "form"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "d-flex" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-black font-16 font-weight-bold flex-grow-1"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.description
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold font-16",
                                                        class: _vm.getAmountColor(
                                                          item.adjustmentAmt
                                                        )
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.getAdjustmentAmount(
                                                                item.adjustmentAmt
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _vm.enableBillingAdjustment &&
                                                    _vm.canDeleteAdjustment
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-2 text-right"
                                                          },
                                                          [
                                                            _c(
                                                              "action-button",
                                                              {
                                                                attrs: {
                                                                  i:
                                                                    "fas fa-minus-circle",
                                                                  variant:
                                                                    "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onDeleteGeneralBillingAdjustment(
                                                                      item,
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Eliminar "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _c("hr"),
                                                _c("div", [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row ml-1" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-2"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-secondary-6 font-14"
                                                            },
                                                            [_vm._v(" Tipo: ")]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-black font-16 font-weight-normal"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.wasManuallyAddedFlagString
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-2 mt-3 mt-md-0 mt-sm-3"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-secondary-6 font-14"
                                                            },
                                                            [_vm._v(" Fecha: ")]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-black font-16 font-weight-normal"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.createDateString
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-2 mt-3 mt-md-0 mt-sm-3"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-secondary-6 font-14"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Usuario: "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-black font-16 font-weight-normal"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.fullName
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6 mt-3 mt-md-0 mt-sm-3 text-right"
                                                        },
                                                        [
                                                          _vm.showObjectionButton(
                                                            item
                                                          )
                                                            ? _c(
                                                                "action-button",
                                                                {
                                                                  class: {
                                                                    "outline-danger": !item.addNewObjection
                                                                  },
                                                                  attrs: {
                                                                    i:
                                                                      "fas fa-gavel",
                                                                    variant:
                                                                      "outline-danger mr-2 mt-n0 px-3"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onToggleObjectionForm(
                                                                        true,
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Objetar "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12 mt-2"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-secondary-6 font-14"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Descripción: "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-black font-16 font-weight-normal"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.getAdjustmentDetailDescription(
                                                                      item
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "mt-4" },
                                                    [
                                                      item.addNewObjection
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "bg-white bordered px-2 py-2"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "icon-view",
                                                                    {
                                                                      staticClass:
                                                                        "mb-3",
                                                                      attrs: {
                                                                        icon:
                                                                          "fa fa-times-square",
                                                                        "icon-background":
                                                                          "#fff",
                                                                        "icon-color":
                                                                          "#FF7058",
                                                                        "icon-size":
                                                                          "18px",
                                                                        title:
                                                                          "Objeción de Ajuste"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "row ml-2 pr-1 mb-3"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-md-8"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "color-secondary-6 font-14"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Comentario: "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs: {
                                                                            rules:
                                                                              "required"
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "default",
                                                                                fn: function({
                                                                                  errors
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "custom-input",
                                                                                      {
                                                                                        attrs: {
                                                                                          "custom-error-msg":
                                                                                            "Favor escribir un comentario.",
                                                                                          error:
                                                                                            errors[0],
                                                                                          "max-length": 2000
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            item.objectionModelComment,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              item,
                                                                                              "objectionModelComment",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "item.objectionModelComment"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            true
                                                                          )
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-md-4"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "font-14 color-gray-6"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Archivo: "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "custom-file-input",
                                                                            {
                                                                              ref:
                                                                                "billingAdjustmentObjected",
                                                                              refInFor: true,
                                                                              attrs: {
                                                                                accept:
                                                                                  ".pdf",
                                                                                "attachment-id":
                                                                                  item.objectionDocumentId,
                                                                                "display-style":
                                                                                  "normal",
                                                                                required:
                                                                                  ""
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.objectionModelSelectedDocument,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "objectionModelSelectedDocument",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "\n                                    item.objectionModelSelectedDocument\n                                  "
                                                                              }
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "mt-2 text-right"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "action-button",
                                                                                {
                                                                                  attrs: {
                                                                                    i:
                                                                                      "fas fa-times-circle",
                                                                                    variant:
                                                                                      "outline-danger ml-2"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      item.addNewObjection = false
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " Cancelar "
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "action-button",
                                                                                {
                                                                                  attrs: {
                                                                                    variant:
                                                                                      "success ml-2 pl-3"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.saveAdjustmentObjectionHandler(
                                                                                        item,
                                                                                        index
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " Guardar "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      !item.addNewObjection &&
                                                      item.objectionStatusId
                                                        ? _c("div", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "bg-white rounded py-2 pr-3"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row ml-1"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col-md-4"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "color-black font-16 font-weight-bold"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " Ajuste Objetado por el Proveedor "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col-md-8 text-right mt-2"
                                                                      },
                                                                      [
                                                                        _vm.showResetObjectionButton(
                                                                          item
                                                                        ) &&
                                                                        _vm.canReturnToPreviousStatus
                                                                          ? _c(
                                                                              "action-button",
                                                                              {
                                                                                attrs: {
                                                                                  i:
                                                                                    "fas fa-undo-alt",
                                                                                  variant:
                                                                                    "outline-success"
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.changeBillingAdjustmentStatusHandler(
                                                                                      item,
                                                                                      _vm
                                                                                        .getBillingObjectionStatusTypes
                                                                                        .Sometida
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Regresar Estatus "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm.showApproveDenyObjectionButton(
                                                                          item
                                                                        ) &&
                                                                        _vm.canAcceptObjection
                                                                          ? _c(
                                                                              "action-button",
                                                                              {
                                                                                attrs: {
                                                                                  i:
                                                                                    "fas fa-check-square",
                                                                                  variant:
                                                                                    "outline-success ml-2"
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.changeBillingAdjustmentStatusHandler(
                                                                                      item,
                                                                                      _vm
                                                                                        .getBillingObjectionStatusTypes
                                                                                        .Aceptada
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Aceptar "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm.showApproveDenyObjectionButton(
                                                                          item
                                                                        ) &&
                                                                        _vm.canRejectObjection
                                                                          ? _c(
                                                                              "action-button",
                                                                              {
                                                                                attrs: {
                                                                                  i:
                                                                                    "fas fa-minus-square",
                                                                                  variant:
                                                                                    "outline-danger ml-2"
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.showRejectBillingAdjustmentHandler(
                                                                                      item
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Rechazar "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm.showDeleteObjectionButton(
                                                                          item
                                                                        )
                                                                          ? _c(
                                                                              "action-button",
                                                                              {
                                                                                attrs: {
                                                                                  i:
                                                                                    "fas fa-times-circle",
                                                                                  variant:
                                                                                    "outline-danger ml-2"
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.deleteObjectionHandler(
                                                                                      item
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Eliminar "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        item.objectionDocumentAttachmentId
                                                                          ? _c(
                                                                              "action-button",
                                                                              {
                                                                                attrs: {
                                                                                  i:
                                                                                    "fas fa-download",
                                                                                  variant:
                                                                                    "success ml-2 pl-3"
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.downloadDocument(
                                                                                      item.objectionDocumentAttachmentId
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row mt-2 ml-1"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col-md-2"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "color-secondary-6 font-14"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " Fecha: "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "color-black font-16 font-weight-normal"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  _vm.$formatDate(
                                                                                    item.objectionStatusDate,
                                                                                    _vm
                                                                                      .$templateDate
                                                                                      .default
                                                                                  )
                                                                                ) +
                                                                                " "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col-md-2 mt-3 mt-md-0 mt-sm-3"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "color-secondary-6 font-14"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " Estatus: "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "color-black font-12"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "em",
                                                                              {
                                                                                staticClass:
                                                                                  "fa fa-circle",
                                                                                class: `color-${_vm.getStatusCircleColor(
                                                                                  item.objectionStatusId
                                                                                )}`
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "font-weight-normal font-16"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      _vm.getObjectionStatusName(
                                                                                        item.objectionStatusId
                                                                                      )
                                                                                    ) +
                                                                                    " "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row mt-3 ml-1"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "color-secondary-6 font-14"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " Comentario: "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "color-black font-16 font-weight-normal"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  item.objectionComment
                                                                                ) +
                                                                                " "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                item.showRejectReason ||
                                                                item.rejectionComment
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "row mt-3 ml-1"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "col-12"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "color-secondary-6 font-14 mb-1"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Razón de Rechazo: "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            item.rejectionComment
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "color-black font-16 font-weight-normal"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          item.rejectionComment
                                                                                        ) +
                                                                                        " "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "validation-observer",
                                                                                      {
                                                                                        ref: `rejectReasonObserver-${index}`,
                                                                                        refInFor: true
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "validation-provider",
                                                                                          {
                                                                                            attrs: {
                                                                                              rules:
                                                                                                "required"
                                                                                            },
                                                                                            scopedSlots: _vm._u(
                                                                                              [
                                                                                                {
                                                                                                  key:
                                                                                                    "default",
                                                                                                  fn: function({
                                                                                                    errors
                                                                                                  }) {
                                                                                                    return [
                                                                                                      _c(
                                                                                                        "custom-text-area",
                                                                                                        {
                                                                                                          attrs: {
                                                                                                            "custom-error-msg":
                                                                                                              "Favor escribir un comentario.",
                                                                                                            error:
                                                                                                              errors[0],
                                                                                                            maxlength: 3000,
                                                                                                            placeholder:
                                                                                                              "Escribe tu comentario"
                                                                                                          },
                                                                                                          model: {
                                                                                                            value:
                                                                                                              item.modelRejectReason,
                                                                                                            callback: function(
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                item,
                                                                                                                "modelRejectReason",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                            expression:
                                                                                                              "item.modelRejectReason"
                                                                                                          }
                                                                                                        }
                                                                                                      )
                                                                                                    ]
                                                                                                  }
                                                                                                }
                                                                                              ],
                                                                                              null,
                                                                                              true
                                                                                            )
                                                                                          }
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "text-right mt-2"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "action-button",
                                                                                          {
                                                                                            attrs: {
                                                                                              i:
                                                                                                "fas fa-times-circle",
                                                                                              variant:
                                                                                                "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                                                                            },
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.cancelRejectBillingAdjustmentHandler(
                                                                                                  item
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " Cancelar "
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _c(
                                                                                          "action-button",
                                                                                          {
                                                                                            attrs: {
                                                                                              i:
                                                                                                "fas fa-save",
                                                                                              variant:
                                                                                                "success pl-4 pr-4"
                                                                                            },
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.saveRejectBillingAdjustmentHandler(
                                                                                                  item,
                                                                                                  index
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " Guardar "
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm.billingAdjustmentDetailList.data.length > 0 &&
                              _vm.billingAdjustmentDetailList.pagination
                                .totalItemCount > 15
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-12 text-right" },
                                    [
                                      _c("pagination", {
                                        attrs: {
                                          data:
                                            _vm.billingAdjustmentDetailList
                                              .pagination,
                                          "show-text": ""
                                        },
                                        on: {
                                          "pagination-go-page":
                                            _vm.goToPageHandlerAdjustmentDetails
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  !_vm.isPreliminar
                    ? _c(
                        "custom-tab-item",
                        {
                          attrs: {
                            active:
                              _vm.billingInfoTabIndex ===
                              _vm.billingInfoTabs.HISTORY,
                            lazy: "",
                            title: "Historial"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onChangeInfoTab(
                                _vm.billingInfoTabs.HISTORY
                              )
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col px-0 px-md-5 px-sm-0" },
                              [
                                _c(
                                  "time-line",
                                  { staticClass: "mt-4" },
                                  _vm._l(_vm.billingTrackingList, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "time-line-item",
                                      {
                                        key: `billing_history_list_${index}`,
                                        attrs: {
                                          icon: _vm.getBillingTrackingIcon(
                                            item.billingTrackingTypeName
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "date",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "color-secondary-6 font-12"
                                                    },
                                                    [_vm._v("Fecha:")]
                                                  ),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "color-black font-16 font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$formatDate(
                                                              item.date,
                                                              _vm.$templateDate
                                                                .longDateWithHour
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "row",
                                            attrs: { id: "main-info" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col additional-evaluation ml-2 mt-1"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-gray-12 font-18 font-weight-bold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.billingTrackingTypeName ||
                                                            "N/A"
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col mt-3 mt-md-0 mt-sm-3"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-secondary-6 font-14"
                                                  },
                                                  [_vm._v(" Usuario: ")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-black font-16 font-weight-normal"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.username) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col mt-3 mt-md-0 mt-sm-3"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-secondary-6 font-14"
                                                  },
                                                  [_vm._v(" Nombre: ")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-black font-16 font-weight-normal"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.userFullName
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col mt-3 mt-md-0 mt-sm-3"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-secondary-6 font-14"
                                                  },
                                                  [_vm._v(" Estatus: ")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "color-black font-16"
                                                  },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "fa fa-circle font-12 mt-1",
                                                      class: `color-${_vm.getCircleColor(
                                                        item.billingStatusId
                                                      )}`
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-16 font-weight-normal ml-1"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.billingStatusName
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        item.trackingComment
                                          ? _c("div", { staticClass: "pt-3" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bg-white p-2 rounded"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "col" },
                                                        [
                                                          _c("em", {
                                                            staticClass:
                                                              "fas fa-info-circle color-orange mr-2"
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "color-secondary-6 font-14"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Descripción: "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "p-3" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-panel-item"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "font-weight-normal ml-2 pl-1"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.trackingComment
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  }),
                                  1
                                ),
                                _vm.visibleShowMoreBillingTracking &&
                                _vm.billingTracking.length > 5
                                  ? _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col text-center" },
                                        [
                                          _c(
                                            "action-button",
                                            {
                                              attrs: {
                                                i: "fas fa-chevron-down",
                                                variant:
                                                  "outline-success custom-view-more"
                                              },
                                              on: {
                                                click:
                                                  _vm.onShowMoreBillingTracking
                                              }
                                            },
                                            [_vm._v(" Ver más Historial ")]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.showPaymentTab
                    ? _c(
                        "custom-tab-item",
                        {
                          attrs: {
                            active:
                              _vm.billingInfoTabIndex ===
                              _vm.billingInfoTabs.PAYMENT,
                            lazy: "",
                            title: "Pago"
                          },
                          on: {
                            click: () => {
                              this.onChangeInfoTab(_vm.billingInfoTabs.PAYMENT)
                              this.billInfo.isPartialPayment = false
                              this.getPaymentInformation()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("div", { staticClass: "row px-5" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-end align-items-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "60px",
                                            height: "60px"
                                          }
                                        },
                                        [
                                          _vm.paymentPercentage < 100
                                            ? _c(
                                                "circle-loader",
                                                {
                                                  attrs: {
                                                    "circle-class":
                                                      "custom-circle-loader",
                                                    "has-icon": "",
                                                    "icon-class": "green-color",
                                                    percentage:
                                                      _vm.paymentPercentage
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "text",
                                                    {
                                                      attrs: {
                                                        fill:
                                                          _vm.paymentPercentage ==
                                                          100
                                                            ? "background-green #000000"
                                                            : "#E5F5EF",
                                                        "font-family":
                                                          "Font Awesome\\ 5 Free",
                                                        "font-size": "18",
                                                        x: "8",
                                                        y: "25.35"
                                                      }
                                                    },
                                                    [_vm._v("  ")]
                                                  )
                                                ]
                                              )
                                            : _c("i", {
                                                staticClass:
                                                  "fas fa-check-circle fa-3x green-color",
                                                class: !_vm.isPendingFundsAlert
                                                  ? "pt-3 "
                                                  : ""
                                              })
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "ml-2 mt-2" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14"
                                          },
                                          [_vm._v(" Monto Total: ")]
                                        ),
                                        _c("div", [
                                          _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-green font-weight-bold font-22"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("price")(
                                                        _vm.totalPurchase
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _vm._v(" / "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-secondary-6 font-16"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("price")(
                                                        _vm.summaryTotals.total
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm.isPendingFundsAlert &&
                                          _vm.enablePendingFundsAlert
                                            ? _c("div", [
                                                _c("em", {
                                                  staticClass:
                                                    "fa fa-bell-exclamation color-primary-14 mr-2"
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "color-primary-14 font-14"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Pendiente de Fondos "
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      ])
                                    ]
                                  )
                                ])
                              ]),
                              _vm.showPaymentTab &&
                              !_vm.billInfo.isPartialPayment &&
                              _vm.billInfo.payments.length < 2 &&
                              !_vm.hasActiveDebtVoucher
                                ? _c("payment-account-number", {
                                    ref: "paymentTab",
                                    attrs: {
                                      "bill-id": _vm.billId,
                                      "bill-info": _vm.billInfo,
                                      "bill-status": _vm.billModel.statusId,
                                      "bill-total-amount":
                                        _vm.summaryTotals.total,
                                      "can-save-voucher-info":
                                        _vm.canSaveVoucherInfo,
                                      "contract-info": {
                                        contractId: _vm.billModel.contractId,
                                        isDirectPayment:
                                          _vm.billModel.isDirectPayment,
                                        year: _vm.billModel.academicYear
                                      },
                                      "distribution-info": _vm.distributionInfo,
                                      "purchase-orders": _vm.purchaseOrders,
                                      "show-update-voucher-status":
                                        _vm.showUpdateVoucherStatus,
                                      "voucher-tracking-info":
                                        _vm.billModel.voucherTrackingInfo
                                    },
                                    on: {
                                      "update:billInfo": function($event) {
                                        _vm.billInfo = $event
                                      },
                                      "update:bill-info": function($event) {
                                        _vm.billInfo = $event
                                      },
                                      "add-purchase-order-numbers":
                                        _vm.onAddPurchaseOrderNumbersHandler,
                                      deleteBillingDigit:
                                        _vm.deleteBillingDigit,
                                      "on-update-voucher-status":
                                        _vm.onUpdateVoucherStatusHandler,
                                      "print-payment-distribution":
                                        _vm.onPrintPaymentDistribution,
                                      "refresh-details":
                                        _vm.refreshPaymentDetails,
                                      saveBillingDigit: _vm.saveBillingDigit
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "documents",
                                          fn: function({ hasPurchaseOrders }) {
                                            return [
                                              _vm.showPaymentDocuments &&
                                              hasPurchaseOrders
                                                ? _c("payment-documents", {
                                                    staticClass: "mt-3",
                                                    attrs: {
                                                      bill: _vm.billId,
                                                      "bill-status-id":
                                                        _vm.billModel.statusId,
                                                      "can-resend-document": !_vm.disableEditDocuments(
                                                        _vm.billInfo
                                                      ),
                                                      disabled:
                                                        _vm.paymentDocumentsReadonly ||
                                                        _vm.disableEditDocuments(
                                                          _vm.billInfo
                                                        ),
                                                      "is-debt-payment":
                                                        _vm.billPaymentHasDebtPurchaseOrderNumber,
                                                      "payment-id":
                                                        _vm.paymentId,
                                                      "voucher-number":
                                                        _vm.payment
                                                          .voucherNumber
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1853329288
                                    ),
                                    model: {
                                      value: _vm.payment,
                                      callback: function($$v) {
                                        _vm.payment = $$v
                                      },
                                      expression: "payment"
                                    }
                                  })
                                : _vm._e(),
                              _vm.showPaymentTab &&
                              _vm.billInfo.isPartialPayment
                                ? _c("partial-account-number", {
                                    ref: "partialTab",
                                    staticClass: "mt-2",
                                    attrs: {
                                      "bill-id": _vm.billId,
                                      "bill-info": _vm.billInfo,
                                      "bill-status": _vm.billModel.statusId,
                                      "bill-total-amount":
                                        _vm.summaryTotals.total,
                                      "can-save-voucher-info":
                                        _vm.canSaveVoucherInfo,
                                      "distribution-info": _vm.distributionInfo,
                                      "purchase-orders": _vm.purchaseOrders,
                                      "show-update-voucher-status":
                                        _vm.showUpdateVoucherStatus
                                    },
                                    on: {
                                      "update:billInfo": function($event) {
                                        _vm.billInfo = $event
                                      },
                                      "update:bill-info": function($event) {
                                        _vm.billInfo = $event
                                      },
                                      cancelPartialPayment: _vm.cancelPayment,
                                      deleteBillingDigit:
                                        _vm.deleteBillingDigit,
                                      "on-select-purchase-order":
                                        _vm.onSelectPurchaseOrderHandler,
                                      "on-update-voucher-status":
                                        _vm.onUpdateVoucherStatusHandler,
                                      "print-payment-distribution":
                                        _vm.onPrintPaymentDistribution,
                                      "refresh-details":
                                        _vm.refreshPaymentDetails,
                                      saveBillingDigit: _vm.saveBillingDigit
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "documents",
                                          fn: function({ payment }) {
                                            return [
                                              _vm.showPaymentDocuments &&
                                              Array.isArray(
                                                payment.billingPurchaseOrderNumbers
                                              ) &&
                                              payment
                                                .billingPurchaseOrderNumbers
                                                .length
                                                ? _c("payment-documents", {
                                                    staticClass: "mt-3",
                                                    attrs: {
                                                      bill: _vm.billId,
                                                      "bill-status-id":
                                                        _vm.billModel.statusId,
                                                      disabled:
                                                        _vm.paymentDocumentsReadonly &&
                                                        !!payment.voucherNumber,
                                                      "is-debt-payment": _vm.paymentHasDebtPurchaseOrderNumber(
                                                        payment
                                                      ),
                                                      "payment-id":
                                                        payment.paymentId,
                                                      "voucher-number":
                                                        payment.voucherNumber
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      461569481
                                    ),
                                    model: {
                                      value: _vm.payment,
                                      callback: function($$v) {
                                        _vm.payment = $$v
                                      },
                                      expression: "payment"
                                    }
                                  })
                                : _vm._e(),
                              _vm.showPaymentTab &&
                              !_vm.billInfo.isPartialPayment
                                ? _c("payment-cancelled-account-number", {
                                    ref: "paymentCancelledTab",
                                    staticClass: "mt-2",
                                    attrs: {
                                      "bill-id": _vm.billId,
                                      "bill-info": _vm.billInfo,
                                      "bill-status": _vm.billModel.statusId,
                                      "bill-total-amount":
                                        _vm.summaryTotals.total,
                                      "can-save-voucher-info":
                                        _vm.canSaveVoucherInfo,
                                      "distribution-info": _vm.distributionInfo,
                                      "purchase-orders": _vm.purchaseOrders,
                                      "show-update-voucher-status":
                                        _vm.showUpdateVoucherStatus
                                    },
                                    on: {
                                      "update:billInfo": function($event) {
                                        _vm.billInfo = $event
                                      },
                                      "update:bill-info": function($event) {
                                        _vm.billInfo = $event
                                      },
                                      cancelPayment: _vm.cancelPayment,
                                      deleteBillingDigit:
                                        _vm.deleteBillingDigit,
                                      "on-select-purchase-order":
                                        _vm.onSelectPurchaseOrderHandler,
                                      "on-update-voucher-status":
                                        _vm.onUpdateVoucherStatusHandler,
                                      "print-payment-distribution":
                                        _vm.onPrintPaymentDistribution,
                                      saveBillingDigit: _vm.saveBillingDigit
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "documents",
                                          fn: function({ payment }) {
                                            return [
                                              _vm.showPaymentDocuments &&
                                              Array.isArray(
                                                payment.billingPurchaseOrderNumbers
                                              ) &&
                                              payment
                                                .billingPurchaseOrderNumbers
                                                .length
                                                ? _c("payment-documents", {
                                                    staticClass: "mt-3",
                                                    attrs: {
                                                      bill: _vm.billId,
                                                      "bill-status-id":
                                                        _vm.billModel.statusId,
                                                      disabled:
                                                        _vm.paymentDocumentsReadonly &&
                                                        !!payment.voucherNumber,
                                                      "is-debt-payment": _vm.paymentHasDebtPurchaseOrderNumber(
                                                        payment
                                                      ),
                                                      "payment-id":
                                                        payment.paymentId,
                                                      "voucher-number":
                                                        payment.voucherNumber
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      461569481
                                    ),
                                    model: {
                                      value: _vm.payment,
                                      callback: function($$v) {
                                        _vm.payment = $$v
                                      },
                                      expression: "payment"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.showSifdeTab
                    ? _c(
                        "custom-tab-item",
                        {
                          attrs: {
                            active:
                              _vm.billingInfoTabIndex ===
                              _vm.billingInfoTabs.CONTRACT_INFO,
                            lazy: "",
                            title: "Información de Contrato"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onChangeInfoTab(
                                _vm.billingInfoTabs.CONTRACT_INFO
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "px-4" },
                            [
                              _c("ContractAddEdit", {
                                attrs: {
                                  "company-id": _vm.companyId,
                                  "contract-id-value": _vm.billModel.contractId,
                                  "read-only": ""
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.showJournalTab
                    ? _c(
                        "custom-tab-item",
                        {
                          attrs: {
                            active:
                              _vm.billingInfoTabIndex ===
                              _vm.billingInfoTabs.JOURNAL,
                            lazy: "",
                            title: "Bitácora"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onChangeInfoTab(
                                _vm.billingInfoTabs.JOURNAL
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "px-4" },
                            [
                              _c("journal-info", {
                                attrs: { "bill-id": _vm.billId }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }